import type React from "react";

import { useFilters } from "routes/patients/PatientsList/PatientsFilter/useFilters";
import { PatientsFilterContext } from "utils/contexts";

interface PatientListContextProvidersProps {
  children: React.ReactNode;
}

export const PatientListContextProviders: React.FC<PatientListContextProvidersProps> = ({ children }) => {
  const filtersState = useFilters();

  return <PatientsFilterContext.Provider value={filtersState}>{children} </PatientsFilterContext.Provider>;
};
